/**
 * DEV NOTE: A new source apps needs to be added to the `sourceApps` variable in
 * automation-ui-core/static/js/context/AppContext.tsx
 *
 */
export const ADS_FLOW = 'ADS_FLOW';
export const ADVANCED_TICKET_SLAS = 'ADVANCED_TICKET_SLAS';
export const AGENT_STUDIO = 'AGENT_STUDIO';
export const CALLING_IVR_APP = 'CALLING_IVR_APP';
export const CMS_FORM_MODULE_FIELD = 'CMS_FORM_MODULE_FIELD';
export const CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL = 'CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL';
export const CRM_MIGRATION = 'CRM_MIGRATION';
export const CUSTOMER_AGENT = 'CUSTOMER_AGENT';
export const DEAL_PIPELINE_SETTINGS = 'DEAL_PIPELINE_SETTINGS';
export const DIRECT_API = 'DIRECT_API';
export const PROJECT_PIPELINE_SETTINGS = 'PROJECT_PIPELINE_SETTINGS';
export const PUBLIC_API = 'PUBLIC_API';
export const PUBLIC_FLOW_API = 'PUBLIC_FLOW_API';
export const ECOMM = 'ECOMM';
export const EMBEDDED_QUOTES = 'EMBEDDED_QUOTES';
export const FEEDBACK = 'FEEDBACK';
export const FEEDBACK_FOLLOW_UP = 'FEEDBACK_FOLLOW_UP';
export const FORECASTING = 'FORECASTING';
export const FORM_FIELD_FOLLOWUP = 'FORM_FIELD_FOLLOWUP';
export const FORM_FOLLOWUP_EMAIL = 'FORM_FOLLOWUP_EMAIL';
export const FORMS_APP = 'FORMS_APP';
export const JOURNEY_STAGE = 'JOURNEY_STAGE';
export const LEAD_FLOW = 'LEAD_FLOW'; // will be deprecated once contextual automation is live
export const LEAD_FLOWS_APP = 'LEAD_FLOWS_APP';
export const MARKETING_EMAIL_AUTOMATED = 'MARKETING_EMAIL_AUTOMATED';
export const RULESETS_PROSPECTING = 'RULESETS_PROSPECTING';
export const SEQUENCES_CONTEXTUAL_AUTOMATION = 'SEQUENCES_CONTEXTUAL_AUTOMATION';
export const SKILL_BASED_ROUTING = 'SKILL_BASED_ROUTING';
export const TICKET_EMAIL_STATUS_SETTING = 'TICKET_EMAIL_STATUS_SETTING';
export const TICKET_PIPELINE_SETTINGS = 'TICKET_PIPELINE_SETTINGS';
export const WORKFLOWS_APP = 'WORKFLOWS_APP';
export const WORKFLOWS_CLASSIC = 'WORKFLOWS_CLASSIC';
export const LEAD_PIPELINE_SETTINGS = 'LEAD_PIPELINE_SETTINGS';
export const LEAD_AUTOMATION_RULES = 'LEAD_AUTOMATION_RULES';
export const CUSTOM_OBJECT_PIPELINE_SETTINGS = 'CUSTOM_OBJECT_PIPELINE_SETTINGS';
export const RULESETS_ACCOUNT_INSIGHTS = 'RULESETS_ACCOUNT_INSIGHTS';
export const RULESETS_GLOBAL_DATA_PROTECTION = 'RULESETS_GLOBAL_DATA_PROTECTION';
export const RULESETS_SECURITY_SETTINGS = 'RULESETS_SECURITY_SETTINGS';
export const RULESETS_HELPDESK_TICKET_REOPENING = 'RULESETS_HELPDESK_TICKET_REOPENING';
export const RULESETS_QUOTE_APPROVALS = 'RULESETS_QUOTE_APPROVALS';
export const RULESETS_BUYER_INTENT = 'RULESETS_BUYER_INTENT';

// never passed by BE
// export const AUTOMATION_PLATFORM_INTERNAL = 'AUTOMATION_PLATFORM_INTERNAL';